import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import FuseAnimate from '@fuse/core/FuseAnimate';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import { useTheme } from '@material-ui/core/styles';

import { openDialog } from 'app/store/fuse/dialogSlice';
import ConfirmDeleteTemplateDialog from '../../components/ConfirmDeleteTemplateDialog';

function FormGeneratorFormHeader({ onSave, onDelete, isEdit, formName }) {
  const theme = useTheme();
  const dispatch = useDispatch();

  const title = isEdit ? formName || 'Edit Form' : 'New Form';

  const handleDeleteClick = () => {
    dispatch(
      openDialog({
        children: <ConfirmDeleteTemplateDialog template={{ name: formName }} onConfirmation={onDelete} />
      })
    );
  };

  return (
    <div className="w-full sticky top-0 z-50 my-4 sm:py-24">
      <div className="flex flex-wrap w-full items-center justify-between max-w-xl mx-auto">
        {/* LEFT */}
        <div className="flex flex-col items-start max-w-full pb-[10px] sm:pb-0 gap-10 mt-6">
          <FuseAnimate animation="transition.slideRightIn" delay={300}>
            <Typography
              className="normal-case flex items-center mb-12"
              component={Link}
              to="/form-generator"
              color="inherit"
              role="button"
            >
              <Icon className="text-20">{theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}</Icon>
              <span className="mx-4">Form Generator</span>
            </Typography>
          </FuseAnimate>

          <FuseAnimate animation="transition.slideLeftIn" delay={300}>
            <Typography className="text-16 sm:text-20 truncate">{title}</Typography>
          </FuseAnimate>
        </div>

        {/* RIGHT */}
        <div className="flex flex-col sm:flex-row gap-10 flex-shrink-0 sm:mb-2 justify-center">
          {!isEdit && (
            <FuseAnimate animation="transition.slideRightIn" delay={300}>
              <Button component={Link} to="/form-generator" variant="outlined" color="secondary">
                Cancel
              </Button>
            </FuseAnimate>
          )}

          {isEdit && (
            <FuseAnimate animation="transition.slideRightIn" delay={300}>
              <Button variant="outlined" color="secondary" onClick={handleDeleteClick}>
                Delete
              </Button>
            </FuseAnimate>
          )}

          <FuseAnimate animation="transition.slideRightIn" delay={300}>
            <Button variant="contained" color="secondary" onClick={onSave}>
              Save Template
            </Button>
          </FuseAnimate>
        </div>
      </div>
    </div>
  );
}

export default FormGeneratorFormHeader;
